<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper (selectionChange)="onStepChange($event)" [linear]="true" labelPosition="bottom" #stepper>
        <mat-step [completed]="!!list.length">
            <ng-template matStepLabel> {{ 'GENERAL.LABEL.POSITION' | translate }}</ng-template>

            <ng-container *ngIf="list.length">
                <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_USERS' | translate }}</h3>
                <mat-chip-set class="chip-list wrap mb-16">
                    <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="removeFromList(item)" *ngFor="let item of list">
                        {{ item.fullName }}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-set>
            </ng-container>

            <div fxLayout="row" fxLayoutAlign="flex-end center" class="mb-12">
                <app-search-outline [searchInput]="searchInput"></app-search-outline>
            </div>

            <div class="w-100-p table-wrapper" *ngIf="dataSource">
                <mat-table #table [dataSource]="dataSource" matSort>
                    <!-- Avatar Column -->
                    <ng-container matColumnDef="avatar">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div class="relative" #avatarCell>
                                <img class="avatar" *ngIf="user?.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- First Name Column -->
                    <ng-container matColumnDef="firstName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #firstNameRow class="text-truncate font-semibold">
                                {{ user.firstName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Last Name Column -->
                    <ng-container matColumnDef="lastName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                            {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #lastNameRow class="text-truncate font-semibold">
                                {{ user.lastName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                            {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" fxHide fxShow.gt-xs>
                            <p #lastNameRow class="text-truncate font-semibold">{{ user.email }}</p>
                        </mat-cell>
                    </ng-container>

                    <!-- Buttons Column -->
                    <ng-container matColumnDef="buttons">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div fxFlex="row" fxLayoutAlign="end center">
                                <app-flat-button
                                    [label]="'GENERAL.BUTTON.ADD'"
                                    (onClick)="addToList(user)"
                                    *ngIf="!user.alreadyMember && !user.selected && !isChat"
                                ></app-flat-button>
                                <app-flat-button [label]="'GENERAL.PROPERTY.SEND_MESSAGE'" [svgIcon]="'chat_bubble'" (onClick)="confirm(user)" *ngIf="isChat"></app-flat-button>
                                <p *ngIf="user.alreadyMember && !isChat">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>
                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(user)" *ngIf="user.selected && !isChat"></app-white-button>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple> </mat-row>
                </mat-table>
                <mat-paginator persistPageSize="module-managers.add-managers-dialog" [length]="isChat ? (totalCountChatUsers$ | async) : (totalCount$ | async)" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"> </mat-paginator>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel> {{ 'GENERAL.LABEL.MANAGER_PERMISSIONS' | translate }}</ng-template>

            <div class="p-24 bg-zinc-50 rounded">
                <form [formGroup]="formGroup">
                    <div fxLayout="row wrap" fxLayoutGap="16px">
                        <div class="mr-16" fxFlex="1 0 calc(50% - 16px)" *ngFor="let managerPermission of filteredPermissions; let i = index">
                            <mat-checkbox [formControl]="permissionsFormArray.at(i)" [class.mb-16]="managerPermission.description">
                                <div fxLayout="column" class="ml-8">
                                    <h3 class="text-sm font-semibold my-0">{{ managerPermission.title | translate }}</h3>
                                    <p class="text-sm font-light mt-4 mb-0" *ngIf="managerPermission.description">{{ managerPermission.description | translate }}</p>
                                </div>
                            </mat-checkbox>
                        </div>
                    </div>
                </form>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>

<div mat-dialog-actions class="pt-0 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.NEXT'" (onClick)="goForward(stepper)" [disabled]="!list.length" *ngIf="stepper.selectedIndex === 0"></app-flat-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="saveSelected()" *ngIf="stepper.selectedIndex === 1"></app-flat-button>
</div>
